export default __webpack_public_path__ + "static/media/57066168_2107551782667567_8578128405508128768_n.1f89f8dc.jpg";